import { render, staticRenderFns } from "./RolesComboManager.vue?vue&type=template&id=1bf43949&scoped=true&"
import script from "./RolesComboManager.vue?vue&type=script&lang=js&"
export * from "./RolesComboManager.vue?vue&type=script&lang=js&"
import style0 from "./RolesComboManager.vue?vue&type=style&index=0&id=1bf43949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf43949",
  null
  
)

export default component.exports